module.exports = __webpack_public_path__ + "img/impact-selected.c22ceb43.svg";